import React from 'react';
import { FloatingInput } from '../../ui/FloatingInput';
import { Button } from '../../ui/Button';
import { repConfig } from '../../../config';
import { Shield, CheckCircle2 } from '../../ui/Icons';

export function StepContact({ data, updateData, onSubmit }) {
  // Phone formatting logic: (XXX) XXX-XXXX
  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    
    if (phoneNumberLength <= 3) return phoneNumber;
    if (phoneNumberLength <= 6) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const handlePhoneChange = (e) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    // Limit to 14 characters: (XXX) XXX-XXXX
    if (formattedValue.length <= 14) {
      updateData({ phone: formattedValue });
    }
  };

  const isComplete = 
    data.firstName && 
    data.lastName && 
    data.phone?.length === 14 && 
    data.email && 
    data.agreedToContact;

  return (
    <div className="w-full space-y-4 md:space-y-8 flex flex-col h-full justify-center py-2">
      <div className="text-center space-y-1">
        <h2 className="font-heading text-2xl md:text-5xl font-bold">Almost done!</h2>
        <p className="text-gray-400 text-xs md:text-lg">Where should {repConfig.name} send your results?</p>
      </div>

      <form 
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }} 
        className="space-y-4 md:space-y-6 bg-dark-card p-5 md:p-10 rounded-3xl border border-white/5 shadow-2xl"
      >
        <div className="grid grid-cols-2 gap-x-4">
          <FloatingInput 
            label="First Name" 
            required 
            value={data.firstName || ''} 
            onChange={e => updateData({ firstName: e.target.value })} 
          />
          <FloatingInput 
            label="Last Name" 
            required 
            value={data.lastName || ''} 
            onChange={e => updateData({ lastName: e.target.value })} 
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
          <FloatingInput 
            label="Phone Number" 
            type="tel" 
            inputMode="tel"
            required 
            value={data.phone || ''} 
            onChange={handlePhoneChange} 
          />
          <FloatingInput 
            label="Email Address" 
            type="email" 
            required 
            value={data.email || ''} 
            onChange={e => updateData({ email: e.target.value })} 
          />
        </div>

        {/* Permission Opt-in */}
        <div className="flex items-start gap-3 pt-2">
          <div className="flex items-center h-5 mt-0.5">
            <input 
              id="agreedToContact" 
              type="checkbox" 
              required 
              checked={data.agreedToContact || false} 
              onChange={(e) => updateData({ agreedToContact: e.target.checked })} 
              className="w-4 h-4 text-brand-blue border-white/20 rounded bg-white/5 focus:ring-brand-blue cursor-pointer" 
            />
          </div>
          <div className="text-[10px] md:text-sm leading-tight text-gray-400">
            <label htmlFor="agreedToContact" className="cursor-pointer">
              I give permission for <span className="text-white font-medium">{repConfig.name}</span> to contact me via phone, email, and text messages regarding my vehicle search. 
              <span className="block mt-1 text-[9px] opacity-60 italic">Consent is not a condition of purchase. Message/data rates may apply.</span>
            </label>
          </div>
        </div>

        <Button 
          type="submit" 
          disabled={!isComplete} 
          className="w-full h-12 md:h-16 text-sm md:text-lg mt-2"
        >
          Secure My Results <CheckCircle2 size={18} className="ml-1" />
        </Button>
      </form>

      <div className="flex items-center justify-center gap-2 text-[10px] md:text-sm text-gray-500">
        <Shield size={14} className="text-brand-blue" />
        <span>Your data is encrypted and never sold to third parties.</span>
      </div>
    </div>
  );
}